import { render, staticRenderFns } from "./ComplianceDocuments.vue?vue&type=template&id=0d8b7bbe&"
import script from "./ComplianceDocuments.vue?vue&type=script&lang=js&"
export * from "./ComplianceDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports